import { useRef, useState } from "react";
import { Modal, ModalFooter, ModalHeading } from "@biteship/atom";
import ImportTable from "./ImportTable";
import { createImportRates } from "../../../../store/action/rates";
import { isAuthenticated } from "../../../../store/action/auth";
import { Dropzone } from "@components/input";

export default function ModalImportRates(props) {
  const { user, token } = isAuthenticated();
  const courierType = user.courier ? user.courier.courierType : "express";
  const ref = useRef(null);
  const [rates, setRates] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);

  const onDropFile = (payload) => {
    payload.pop();
    setRates(payload.map((rate) => {
      if (rate["Base Price"] === "") return null; // Skip if Base Price is empty
      return { ...rate, submitted: false };
    }).filter(Boolean)); // Filter out null values
  };

  const onSubmit = async () => {
    try {
      setSubmitLoading(true);
      const importResults = [];
      for (let i = 0; i < rates.length; i++) {
        const res = await createImportRates(token, rates[i], courierType);
        if (res.success) {
          importResults.push({ uploadStatus: "success" });
        } else {
          importResults.push({ uploadStatus: "failed" });
        }
        setRates((prevRates) => {
          const newRates = [...prevRates];
          newRates[i].submitted = true;
          return newRates;
        });
      }
      setSubmitLoading(false);
      props.onSubmit(importResults);
    } catch (error) {
      console.log(error);
    }
  };

  const handleClose = () => {
    setRates([]); // Reset rates on close
    props.onClose();
  };

  return (
    <Modal show={props.show} onClose={handleClose} size={rates.length > 0 ? "5xl" : "lg"}>
      <ModalHeading title="Import Rates" onClose={handleClose} />
      {rates.length > 0 ? (
        <ImportTable data={rates} courierType={courierType} loading={submitLoading} />
      ) : (
        <div ref={ref} className="pb-6 pt-4 px-6">
          <Dropzone onDrop={onDropFile} convertTo="json" />
        </div>
      )}
      <div className="text-center mt-4">
        <a href={courierType === "express" ? "https://docs.google.com/spreadsheets/d/11HKDd6Za8eCagBTDGLxtw3DQdHjdIALN/edit?usp=sharing&ouid=112981478929683974184&rtpof=true&sd=true" : "https://docs.google.com/spreadsheets/d/1ysS1haavM_JyB2rZVVVc3W34vkAH-HF_/edit?usp=sharing&ouid=112981478929683974184&rtpof=true&sd=true"} target="_blank" rel="noopener noreferrer">
          <button className="btn btn-link">Click here to download the template</button>
        </a>
      </div>
      <ModalFooter
        primaryButton={{ title: "Submit", loading: submitLoading, onClick: () => onSubmit() }}
      />
    </Modal>
  );
}
